module.exports = __webpack_public_path__ + "img/Coin BankB03.d9242c96.png";